<template>
  <div class="product-category-page">
    <br />
    <div>
      <input
        class="prodCatName"
        type="text"
        v-model="productCategory.name"
        :disabled="!isEditing"
        :class="{ view: !isEditing }"
      />
    </div>
    <br />
    <div class="catDetails">
      <div class="tagline">{{ $t('tagline') }}:</div>
      <b-form-textarea
        class="inactive"
        type="text"
        v-model="productCategory.hero_tagline"
        :state="productCategory.hero_tagline.length <= 40"
        :disabled="!isEditing"
        :class="{ active: !isActive, view: !isEditing }"
      ></b-form-textarea>
      <br />
    </div>
    <br />
    <div
      class="edit-btn"
      @click="
        isEditing = !isEditing
        isActive = !isActive
      "
    >
      <font-awesome-icon class="icon" icon="edit" />
      <!-- {{ isEditing ? 'Save new changes' : 'Edit product details' }} -->
    </div>
    <br />
    <!-- <div class="edit-btn" v-if="isEditing" @click="isEditing = false"><font-awesome-icon class="icon" icon="times" /></div> -->
    <div class="edit-btn" v-if="isEditing" @click="changeCategoryDetails">
      <font-awesome-icon class="icon" icon="save" />
    </div>

    <hr />
    <figure class="about-img3">
      <img
        class="uploadExample"
        src="../assets/static/images/uploadExamples/coverImage_example.jpg"
      />
    </figure>
    <CoverImageUpload
      :isProductFlowEnabled="false"
      :prodCatId="String(productCategory.id)"
      :imageUrl="productCategory.img_path"
    ></CoverImageUpload>
    <!-- <br/>
    <hr/>
    <br />
    <h3>Products in this category</h3>
    <ProductCard
      v-for="product in product.products"
      :key="product.id"
      :product="product"
      class="card-columns"
    /> -->
    <!--FILTERING BY CATEGORIES NOT WORKING!!!-->
    <br />
    <br />
    <div class="trash-btn" @click="deleteProductCategory">
      <font-awesome-icon class="icon" icon="trash" /><span>
        {{ $t('removeProdCat') }}</span
      >
    </div>
    <br />
  </div>
</template>

<script>
import CoverImageUpload from '../components/ui/CoverImageUpload.vue'
// import ProductCard from '@/components/ui/ProductCard.vue'
import { mapState } from 'vuex'

export default {
  components: {
    CoverImageUpload,
    // ProductCard
  },
  data() {
    return {
      id: this.productCategory.id,
      isEditing: false,
      isActive: false,
    }
  },
  methods: {
    deleteProductCategory() {
      if (confirm('are you sure?')) {
        this.$store
          .dispatch('experience/removeExperienceCategory', this.id)
          .then(() => {
            this.$router.push({
              path: '/products/en',
            })
          })
          .catch((e) => console.log(e))
      }
    },
    changeCategoryDetails() {
      if (
        confirm(
          'are you sure? This will rewrite excisting experience category details'
        )
      ) {
        this.$store.dispatch(
          'experience/updateExperienceCategoryById',
          this.productCategory
        )
        this.isEditing = !this.isEditing
        this.isActive = !this.isActive
      }
    },
  },
  created() {
    this.$store.dispatch('experience/fetchExperienceCategories')
  },
  computed: mapState(['experience', 'client']),

  props: {
    productCategory: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.prodCatName {
  text-align: center;
  padding-left: 50px;
  font-size: 3em;
  font-weight: 600;
  width: 60%;
}

.catDetails {
  width: 45%;
  margin: auto;
  text-align: left;
  background: var(--grey-light);
  border-radius: 15px;
}

.uploadDetails {
  font-size: 1.5em;
}

.about-img3 {
  display: inline-block;
  width: 100%;
  max-width: 400px;
  text-align: center;
  vertical-align: top;
}

.uploadExample {
  max-width: 300px;
  width: 100%;
}

textarea {
  padding: 10px;
  width: 500px;
  height: 50px;
}

@media screen and (max-width: 450px) {
  textarea {
    width: 90%;
    height: 70px;
  }
  .uploadDetails {
    font-size: 1.2em;
  }

  .prodCatName {
    font-size: 2em;
    width: 100%;
    margin-left: 0px;
    padding: 0px;
  }
  .product-category-page div {
    text-align: left;
  }
  .tagline {
    text-align: left;
    margin-left: 10px;
  }
  .catDetails {
    width: 90%;
    padding: 10px;
  }
  .trash-btn {
    width: auto;
    margin: 0 50px;
  }
}

.edit-btn {
  background: var(--primary);
  color: var(--bright);
  padding: 0.3em;
  margin: auto !important;

  letter-spacing: 3px;
  border: none;
  border-radius: 3.5px;
  width: 40px;
  height: 30px;
}

.icon {
  font-size: 1.3em;
  padding: 1px;
}
.active {
  border-radius: 3.5px;
  background: none !important;
  font-weight: 600;
  font-style: normal !important;
}
.inactive {
  background: rgba(
    185,
    123,
    66,
    0.4
  ); /* when mouse over to the drop zone, change color */
  border-radius: 3.5px;
  font-style: italic;
}
.trashIcon {
  color: red;
  border: red 2px solid;
  padding: 3px;
}

@media screen and (min-width: 800px) {
  .catDetails {
    padding: 50px;
  }
}
</style>
